
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import infoTitle from "@/components/info-title/info-title.vue";
import { calledMeasurementFee } from "@/api/api-basic-websocket";
import { sendSyncfeeRatecmd } from "@/api/api-basic";
import { getFeeByPile, getFeeList } from "@/api/oms-operation-service";
import i18n from "@/config/i18n";
// import { pushMsg } from "@/api/api-basic-websocket";
// import tio from "@/common/tiows";
@Component({
  components: {
    "pi-info-title": infoTitle
  }
})
export default class CollectionDataRateConfig extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private search!: objAny;
  @Prop({
    default: () => {
      return {};
    }
  })
  private gunData!: objAny;
  @Prop({
    default: () => {
      return {};
    }
  })
  private tiows!: objAny;
  @Prop({ default: 0 }) private isOpen!: number;
  private formInline: objAny = {
    rateName: ""
  };
  private slotFlagObj: objAny = {
    "1": i18n.t("ratamanage.jian"),
    "2": i18n.t("ratamanage.feng"),
    "3": i18n.t("ratamanage.ping"),
    "4": i18n.t("ratamanage.gu")
  };
  private sendMsgText = "";
  private returnMsgText = "";
  private loading = false;
  private rateList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("dataConfig.slotFlag"),
      key: "slotFlag",
      minWidth: 130,
      slot: "slotFlag"
    },
    {
      title: i18n.t("dataConfig.slotElecPrice"),
      key: "slotElecPrice",
      minWidth: 130
    },
    // {
    //   title: "平台电价(元/kWh)",
    //   key: "platformSlotElecPrice",
    //   minWidth: 130
    // },
    {
      title: i18n.t("dataConfig.slotServicePrice"),
      key: "slotServicePrice",
      minWidth: 130
    },
    // {
    //   title: "平台电价(元/kWh)",
    //   key: "platformSlotServicePrice",
    //   minWidth: 130
    // },
    {
      title: i18n.t("dataConfig.time"),
      key: "time",
      minWidth: 130,
      slot: "time"
    }
    // {
    //   title: "平台时间段",
    //   key: "platformTime",
    //   minWidth: 130,
    //   slot: "platformTime"
    // }
  ];
  private elecFeeItemVos: object[] = [];
  private platformElecFeeItemVos: object[] = [];

  async getFeeByPile(pilePkId: string) {
    const ret = await getFeeByPile({ pilePkId: pilePkId });
    if (ret.status == this["$config"].apiStatus) {
      this.formInline.ratePkid = "";
    }
  }
  async getFeeList() {
    const ret = await getFeeList({});
    if (ret.status == this["$config"].apiStatus) {
      this.rateList = ret.data;
    }
  }
  // public rateChange(val: string) {
  //   this.rateList.map((item: objAny) => {
  //     if (item.feePkId == val) {
  //       this.formInline.rateName = item.feeName;
  //     }
  //   });
  // }

  async getRateTemp() {
    if (this.search.pilePkId) {
      const ret = await calledMeasurementFee({
        pilePkId: this.search.pilePkId,
        type: 1,
        content: "",
        gunPkId: "" //this.search.gunPkId
      });
      if (ret.status == this["$config"].apiStatus) {
        console.log("发送成功");
      }
    }
  }

  async getTableList(data: objAny): Promise<void> {
    this.formInline.rateName = data.feeName;
    this.elecFeeItemVos = data.elecFeeItemVos || [];
    this.platformElecFeeItemVos = data.platformElecFeeItemVos || [];
    // if (data.elecFeeItemVos.length == 0) {
    //   const arr: object[] = [];
    //   data.platformElecFeeItemVos.map((item: objAny) => {
    //     item.platformSlotElecPrice = item.slotElecPrice + "";
    //     item.platformSlotServicePrice = item.slotServicePrice + "";
    //     item.platformBeginTime = item.beginTime;
    //     item.platformEndTime = item.endTime;
    //     item.slotElecPrice = "";
    //     item.slotServicePrice = "";
    //     arr.push(item);
    //   });
    //   this.tableList = arr;
    // } else {
    //   const arr: object[] = [];
    //   data.elecFeeItemVos.map((item: objAny) => {
    //     let platformData: objAny = {};
    //     data.platformElecFeeItemVos.map((platform: objAny) => {
    //       if (
    //         item.beginTime == platform.beginTime &&
    //         item.endTime == platform.endTime &&
    //         item.slotFlag == platform.slotFlag
    //       ) {
    //         platformData = platform;
    //       }
    //     });
    //     if (platformData && platformData["pkid"]) {
    //       item.platformSlotElecPrice = platformData["slotElecPrice"];
    //       item.platformSlotServicePrice = platformData["slotServicePrice"];
    //       item.platformBeginTime = platformData["beginTime"];
    //       item.platformEndTime = platformData["endTime"];
    //       item.platformData = platformData;
    //     }
    //     arr.push(item);
    //   });
    //   this.tableList = arr;
    // }
  }
  async sendSyncfeeRatecmd() {
    const ret = await sendSyncfeeRatecmd({
      serialNumbers: [this.gunData.sn],
      feePkId: this.formInline.ratePkid
      // serialNumbers: [this.search.pilePkId]
    });
    if (ret.status == this["$config"].apiStatus) {
      this.$Message.success(i18n.t("dataConfig.issueSuccess"));
    }
  }
  async send() {
    if (this.isOpen == 2 && this.search.gunPkId && this.search.gunPkId != "") {
      const ret = await calledMeasurementFee({
        pilePkId: this.search.pilePkId,
        type: 4,
        content: this.sendMsgText,
        gunPkId: this.search.gunPkId
      });
      if (ret.status == this["$config"].apiStatus) {
        console.log("发送成功");
      }
    }
  }
  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  public convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }
  public returnMsgTextData(str: string) {
    this.returnMsgText = str;
  }

  mounted() {
    this.getFeeList();
  }
}
